import React, { useState, useEffect } from "react";
import "./Games.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-multi-carousel/lib/styles.css";
import GameCard2 from "../../component/GameCard2/GameCard2";
import GameCardEffect from "../../component/GameCardEffect /GameCardEffect";
import gamesData from "../../dataset/llk88.json";
import { BrowserRouter as Router, Route, Switch, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Games() {
  const [isloading, setIsLoading] = useState(true);
  const { category } = useParams(); // ดึงค่าพารามิเตอร์จาก URL
  const { t } = useTranslation(); // ดึงฟังก์ชันแปลจาก useTranslation

  useEffect(() => {
    // ตั้งเวลาเพื่อจำลองการโหลดข้อมูล
    const timer = setTimeout(() => {
      setIsLoading(false); // ตั้งค่าให้ isloading เป็น false หลังจาก 2 วินาที
    }, 10);

    // ลบ timer เมื่อคอมโพเนนต์ unmount
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <p className="title log text-light mb-0" style={{ fontSize: "18px", fontWeight: "bold", textDecoration: "none" }}>
        {t(category)}
      </p>

      <div className="row p-0 ">
        {isloading ? (
          // ถ้า isloading เป็น true (กำลังโหลด) ให้แสดง GameCardEffect
          gamesData.map((ele) => {
            return (
              <div className="col-6 col-sm-6 col-lg-3 text-center" key={ele.id}>
                <GameCardEffect />
              </div>
            );
          })
        ) : (
          // ถ้า isloading เป็น false (โหลดข้อมูลเสร็จแล้ว) ให้แสดงข้อมูลที่กรองตาม keywords
          gamesData
            .filter((ele) => category === "all-games" || ele.game_category.includes(category))
            .map((ele) => {
              return (
                <div className="col-6 col-sm-6 col-lg-3 text-center" key={ele.id}>
                  <GameCard2 element={ele} />
                </div>
              );
            })
        )}
      </div>
    </>
  );
}

export default Games;
